/**
 * Helper method to be used with filter to remove elements that are undefined
 * This additionaly updates the resulting array no longer have `<T | undefined>` typing
 */
export const noUndefined = <T>(item: T | undefined): item is T => !!item;

export function onlyUnique<T = unknown>(value: T, index: number, array: T[]) {
  return array.indexOf(value) === index;
}
